<dekra-main-nav slot="nav" [hideIcons]="true" [orientation]="Alignment.HORIZONTAL">
  <dekra-label slot="name" routerLink="/">{{ 'BUI.HEADER.APPLICATION_NAME'|translate }}</dekra-label>
</dekra-main-nav>
